import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgGlobe = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 20,
	height: 20,
	fill: "none",
	viewBox: "0 0 20 20",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		stroke: "currentColor",
		strokeLinejoin: "round",
		strokeWidth: 1.5,
		d: "M18.25 10A8.25 8.25 0 0 1 10 18.25M18.25 10A8.25 8.25 0 0 0 10 1.75M18.25 10H1.75M10 18.25A8.25 8.25 0 0 1 1.75 10M10 18.25c1.795 0 3.25-3.694 3.25-8.25S11.795 1.75 10 1.75m0 16.5c-1.795 0-3.25-3.694-3.25-8.25S8.205 1.75 10 1.75M1.75 10A8.25 8.25 0 0 1 10 1.75"
	})]
});
const ForwardRef = forwardRef(SvgGlobe);
export { ForwardRef as ReactComponent };
